module.exports = __webpack_public_path__ + "static/media/portfolio 10.f2ae6999.JPG";